import { Component, OnInit, OnDestroy } from '@angular/core';
import { BackendService } from 'src/app/services/backend.service';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-instituciones',
  templateUrl: './instituciones.component.html',
  styleUrls: ['./instituciones.component.scss']
})
export class InstitucionesComponent implements OnInit {

    showNew: Boolean = false;
    showDelete: Boolean = false;
    showEdit: Boolean = false;
    error = false;
    errorMessage: String = '';
    dataLoading = false;
    private querySubscription;
    savedChanges = false;
    instituciones;
    admin;
    institution;
    public pushRightClass: string;
    hasError = false;
    id;

  constructor(private translate: TranslateService, private backendService: BackendService, private router: Router) {
  this.translate.addLangs(['es', 'pt']);

  this.router.events.subscribe(val => {
      if (
          val instanceof NavigationEnd &&
          window.innerWidth <= 992 &&
          this.isToggled()
      ) {
          this.toggleSidebar();
      }
  });
}

isToggled(): boolean {
    const dom: Element = document.querySelector('body');
    return dom.classList.contains(this.pushRightClass);
}

changeLang(language: string) {
    this.translate.use(language);
}

toggleSidebar() {
    const dom: any = document.querySelector('body');
    dom.classList.toggle(this.pushRightClass);
}

  ngOnInit() {
    if (localStorage.length <= 0) {
        this.router.navigate(['../login']);
      } else {
          if (localStorage.getItem('token') == null) {
              this.router.navigate(['../login']);
          } else {
            this.isAdmin();
            this.getInstitution();
            this.pushRightClass = 'push-right';
          }
      }
  }

  getInstitution() {
    console.log('getInstitution ----institution.component.ts --------PAASO POR getInsitutition');
    this.dataLoading = true;
    this.querySubscription = this.backendService.getInstitution().subscribe((res) => {
        if (res['errorCode'] > 0) {
            this.error = false;
            this.errorMessage = '';
            this.dataLoading = false;
            res['data'].sort((a, b) => a.number - b.number);
            this.instituciones = res['data'];
            console.log(this.instituciones);
        } else {
            this.error = true;
            this.errorMessage = res['errorMessage'];
            this.dataLoading = false;
        }
    },
        (error) => {
            if (error.status === 401 || error.status === 403) {
                localStorage.setItem('token', '');
                this.router.navigate(['/login']);
            }
            this.error = true;
            this.errorMessage = error.message;
            this.dataLoading = false;
        },
        () => {
            this.dataLoading = false;
        });
    }

    onNew() {
        this.showNew = true;
    }

    onCancel() {
        this.showNew = false;
    }

    onEdit(id) {
        this.showEdit = true;
        this.institution = id;

    }

    isAdmin() {
        this.admin = localStorage.getItem('admin');
        if (this.admin === 1) {
            this.router.navigate(['/layout/dashboard']);
        }
    }

    offEdit() {
        this.showEdit = false;

    }

    onDelete(id) {
        this.showDelete = true;
        this.institution = id;
    }

    reloadRoute() {
        window.location.href = window.location.href;
    }

    /*deleteInstitution(id) {
        console.log('deleteInstitution ----delete.component.ts --------PAASO POR deleteInsitutition');
        this.dataLoading = true;
        this.querySubscription = this.backendService.deleteInstitution(id).subscribe((res) => {
        if (res['errorCode'] > 0) {
            this.error = false;
            this.errorMessage = '';
            this.dataLoading = false;
            this.savedChanges = true;
            this.reloadRoute();
        } else {
            this.error = true;
            this.errorMessage = res['errorMessage'];
            this.dataLoading = false;
        }
    },
        (error) => {
                if (error.status === 401 || error.status === 403) {
                    localStorage.setItem('token', '');
                    this.router.navigate(['/login']);
                }
            this.error = true;
            this.errorMessage = error.message;
            this.dataLoading = false;
        },
        () => {
            this.dataLoading = false;
        });
    }*/

    offDelete() {
        this.showDelete = false;
    }
    setInstitution(formData) {
        console.log('setInstitution ----set.component.ts --------PAASO POR setInsitutition');
        this.hasError = false;
        this.dataLoading = true;

        this.querySubscription = this.backendService.setInstitution(formData).subscribe((res) => {
        if (res['errorCode'] > 0) {
            this.error = false;
            this.errorMessage = '';
            this.dataLoading = false;
            this.savedChanges = true;
            this.reloadRoute();
        } else {
            this.error = true;
            this.errorMessage = res['errorMessage'];
            this.dataLoading = false;
        }
        },
        (error) => {
                if (error.status === 401 || error.status === 403) {
                    localStorage.setItem('token', '');
                    this.router.navigate(['/login']);
                }
            this.error = true;
            this.errorMessage = error.message;
            this.dataLoading = false;
        },
        () => {
            this.dataLoading = false;
        });
    }

  updateInstitution(formData) {
    this.dataLoading = true;
    this.hasError = false;
    this.querySubscription = this.backendService.updateInstitution(formData).subscribe((res) => {
      if (res['errorCode'] > 0) {
          this.error = false;
          this.errorMessage = '';
          this.dataLoading = false;
          this.savedChanges = true;
          this.reloadRoute();
      } else {
          this.error = true;
          this.errorMessage = res['errorMessage'];
          this.dataLoading = false;
      }
  },
      (error) => {
            if (error.status === 401 || error.status === 403) {
                localStorage.setItem('token', '');
                this.router.navigate(['/login']);
            }
          this.error = true;
          this.errorMessage = error.message;
          this.dataLoading = false;
      },
      () => {
          this.dataLoading = false;
      });
    }

  ngOnDestroy() {
    if (this.querySubscription) {
      this.querySubscription.unsubscribe();
    }
  }
}
